import { ReactElement } from 'react';

import { getSharedLink, getSharedProperty } from '../../../getters';
import { QuickLinksContent, SitecoreItem } from '../../../types';
import { SearchTitleHeader } from './SearchTitleHeader';

type QuickLinksProps = {
  quickLinks: SitecoreItem<QuickLinksContent>;
};

export const QuickLinksView = ({ quickLinks }: QuickLinksProps): ReactElement => {
  const { fields } = quickLinks;

  return (
    <>
      {fields.QuickLinks.length ? (
        <>
          {/*todo: missing translation*/}
          <SearchTitleHeader
            title={
              fields.QuickLinksLabel?.value
                ? fields.QuickLinksLabel?.value
                : getSharedProperty(fields.QuickLinksLabelShared?.fields, 'Phrase')?.value
            }
          />
          <div
            className="mb-10 mt-1.5 grid w-full grid-cols-1 gap-2 xs:grid-cols-2 lg:grid-cols-3"
            role="list"
          >
            {fields?.QuickLinks.map((link) => {
              const linkField = getSharedLink(link.fields, 'Link');
              return (
                <a key={`quicklink-${link.id}`} href={linkField?.value?.href}>
                  <div
                    className="cursor-pointer border-b border-solid border-gray-100 pb-1"
                    role="listitem"
                  >
                    {link.fields.Title?.value
                      ? link.fields.Title?.value
                      : getSharedProperty(link.fields.TitleDictionary?.fields, 'Phrase')?.value}
                  </div>
                </a>
              );
            })}
          </div>
        </>
      ) : null}
    </>
  );
};
